module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (39).b9183742.jpg";